export const STICKER_INTRINSIC_SIZE_FALLBACK = 200;
